/*
* 哈佛购课页面/会员中心页
*/
import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import QRCode from 'qrcode.react';
import Load from '../../template/Load/Load';
import UA from '../../utils/ua';
import AXIOS from '../../api/axios';
import { parseQuery } from '../../utils/tools';

import './style.less';

import vipImg from '../../static/images/vip.png';
import vipNoImg from '../../static/images/vip_no.png';

const queryObj = parseQuery(window.location.search.slice(1))

class MemberPage extends Component {
    constructor(props){
        super(props);
        this.state = {
            expireDate: null,
            channelId: Number(queryObj.channel) >= 1000? queryObj.channel : null,
            completeRander: false // 加载中
        };
    }

    componentDidMount(){
        const { channelId } = this.state;
        let data = {
            userId: queryObj.stuid
        };
        if(channelId) data.channelId = channelId;
        this.getStuCourse();
//        setInterval(()=>{
//            this.getStuCourse()
//        }, 4000)
        AXIOS.getGoodsInfo({ data }, (res, err) => {
            if (err) console.log(err)
            else{
                this.setState({ list:res })
            }
        })
    }

    // 获取学生当前套餐信息
    getStuCourse = () => {
        AXIOS.getStuCourse({ data: { stuId: queryObj.stuid, courseId: 210 } },(res, err)=>{
            if (err) {
                // alert(JSON.stringify(err))
            } else {
                if(res[0]){
                    const expireDate = new Date(res[0].expireDate).getTime() + 86400000;
                    if (expireDate > this.state.curExpireDate && (UA.winClient || UA.androidTabClient)) { // 购买之后则关闭付款二维码
                        this.setState({ showErweima: false });
                    }
                    this.setState({ 
                        expireDate: expireDate - new Date().getTime() > 0 ? res[0].expireDate : null,
                        completeRander: true,
                        curExpireDate: expireDate,
                        stuStatus: res[0].stuStatus
                    })
                } else {
                    this.setState({
                        completeRander: true
                    })
                }
            }
        });
    }

    // 点击续费或购买
    handleClick = (index) => {
        if(this.state.list[index].available){
            this.setState({ goodsNo: this.state.list[index].goodsNo });
            setTimeout(() => {
                window.location.href = `${window.location.origin}/pay/nasapay${window.location.search}&goodsId=${this.state.list[index].id}`;
            }, 300)
        } else {
            alert(this.state.list[index].unavailableReason)
        }
    }
    render(){
        const { 
            showErweima,
            goodsNo,
            list = [],
            expireDate,
            stuStatus = 0,
            completeRander
        } = this.state;
        const item = list.map((ele, index) => {
            return(
                <div className="item" key={index} style={{backgroundImage:`url(${ele.posterUrl})`}}>
                    <div className="text_wrap">
                        <div className="name">{ele.name}</div>
                        <div className="price">￥{ele.totalAmount/100} 元</div>
                        <div className="date">有效期：{ele.expireDays} 天</div>
                    </div>
                    <span></span>
                    <div className="btn" onClick={this.handleClick.bind(this,index)}>{stuStatus !== 0? '续费': '购买'}</div>
                </div>
            )
        })
        // alert(document.body.clientWidth)
        return(
            <DocumentTitle title={'会员中心'}>
                <React.Fragment>
                { completeRander?
                    <div className={`container member_new ${ UA.mobileClient ? '' : 'pc'}`}>
                        <div className="content_top_wrap">
                            <img src={ expireDate ? vipImg : vipNoImg } alt="img"/>
                            <div className="content_bottom">
                                <div className="title_wrap">
                                    <h2>{ expireDate ? '哈佛外教百科英语课程包' : '您还不是哈佛外教百科英语课程的会员哦' }</h2>
                                    { (expireDate && (stuStatus === 2 || stuStatus === 4))? <h3>有效期至：{expireDate}</h3> : null }
                                </div>
                                <div className="text_wrap">
                                    <h3>课程说明</h3>
                                    <p>
                                    1.购买后请在有效期内使用，此课程仅限于哈佛外教百科英语课程系列；<br></br>
                                    2.获取其它客户端下载链接和更多活动信息，请关注“爱课AirCourse”服务号；<br></br>
                                    3.购买后7日内可无理由退款；<br></br>
                                    4.如有其它任何疑问，请联系4008-874-877。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="content_bottom_wrap">
                            <h2>全部套餐</h2>
                            <div className="item_wrap">
                                {item}
                            </div>
                        </div>
                    </div> : null
                }
                {!completeRander ? <Load /> : null}
                {showErweima?
                    <div className="erweima_wrap ngk" onClick={()=>{this.setState({showErweima:false})}}>
                        <div className="erweima">
                            <QRCode size={148} value={`https://client.aircourses.com/pay/paylink?channel=${queryObj.channel}&userid=${queryObj.stuid}&goodsno=${goodsNo}`} fgColor='#333' />
                            <span>请用手机支付宝或微信扫码付款</span>
                        </div>
                    </div> : null
                }
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default MemberPage;



// WEBPACK FOOTER //
// ./src/components/memberNewPage/MemberNewPage.jsx